// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
  -webkit-text-fill-color: #777777 !important;
}

.response-message {
  margin-bottom: 20px;
}

.swal2-icon.swal2-success .swal2-success-ring {
  border: 0.25em solid #00CAFF;
}

.swal2-icon.swal2-success [class^=swal2-success-line] {
  background-color: #00CAFF;
}

.swal2-icon.swal2-success [class^=swal2-success-line] {
  background-color: #00CAFF;
}

.btn-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.icone-check .path-1 {
  stroke-dasharray: 0;
  stroke-dashoffset: 0;
  opacity: 0;
  animation: dash-stroke-1 2s ease-out forwards 0.5s;
}
@keyframes dash-stroke-1 {
  0% {
    stroke-dasharray: 0, 1100;
  }
  5% {
    opacity: 1;
  }
  100% {
    stroke-dasharray: 1100, 1100;
    opacity: 1;
  }
}
.icone-check .path-2 {
  stroke-dasharray: 0;
  stroke-dashoffset: 0;
  opacity: 0;
  animation: dash-stroke-2 3s ease forwards 0.95s;
}
@keyframes dash-stroke-2 {
  0% {
    stroke-dasharray: 0, 1100;
  }
  5% {
    opacity: 1;
  }
  100% {
    stroke-dasharray: 1100, 1100;
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/auth/components/recuperar-senha/recuperar-senha.component.scss"],"names":[],"mappings":"AAEA;;;;EAII,8CAAA;EACA,yDAAA;EAAA,iDAAA;EACA,2CAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,4BAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,mBAAA;EACA,YAAA;AADJ;;AAKI;EACI,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,kDAAA;AAFR;AAII;EACI;IACI,yBAAA;EAFV;EAIQ;IACE,UAAA;EAFV;EAIQ;IACE,4BAAA;IACA,UAAA;EAFV;AACF;AAKI;EACI,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,+CAAA;AAHR;AAKI;EACI;IACI,yBAAA;EAHV;EAKQ;IACE,UAAA;EAHV;EAKQ;IACE,4BAAA;IACA,UAAA;EAHV;AACF","sourcesContent":["@import '../../../../../sass/variables';\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n    -webkit-box-shadow: 0 0 0px 1000px white inset;\n    transition: background-color 5000s ease-in-out 0s;\n    -webkit-text-fill-color: $cinza-600 !important;\n}\n\n.response-message {\n    margin-bottom: 20px;\n}\n\n.swal2-icon.swal2-success .swal2-success-ring {\n    border: 0.25em solid #00CAFF;\n}\n\n.swal2-icon.swal2-success [class^='swal2-success-line'] {\n    background-color: #00CAFF;\n}\n\n.swal2-icon.swal2-success [class^='swal2-success-line'] {\n    background-color: #00CAFF;\n}\n\n.btn-disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n\n.icone-check {\n    .path-1 {\n        stroke-dasharray: 0;\n        stroke-dashoffset: 0;\n        opacity: 0;\n        animation: dash-stroke-1 2s ease-out forwards 0.5s;\n    }\n    @keyframes dash-stroke-1 {\n        0% {\n            stroke-dasharray: 0, 1100;\n          }\n          5% {\n            opacity: 1;\n          }\n          100% {\n            stroke-dasharray: 1100, 1100;\n            opacity: 1;\n          }\n    }\n\n    .path-2 {\n        stroke-dasharray: 0;\n        stroke-dashoffset: 0;\n        opacity: 0;\n        animation: dash-stroke-2 3s ease forwards 0.95s;\n    }\n    @keyframes dash-stroke-2 {\n        0% {\n            stroke-dasharray: 0, 1100;\n          }\n          5% {\n            opacity: 1;\n          }\n          100% {\n            stroke-dasharray: 1100, 1100;\n            opacity: 1;\n          }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
